const listeners = new Set();

const emptyNav = {
    total: 0,
    activeIndex: 0,
    columnLabel: "",
    columnMatchIndex: 0,
    columnMatchTotal: 0,
    goPrev: null,
    goNext: null,
};

let navState = { ...emptyNav };

export function updateChartTableSearchNav(next) {
    navState = next;
    listeners.forEach((listener) => listener(navState));
}

export function resetChartTableSearchNav() {
    updateChartTableSearchNav({ ...emptyNav });
}

export function subscribeChartTableSearchNav(listener) {
    listeners.add(listener);
    listener(navState);
    return () => listeners.delete(listener);
}
